export const SET_PROJECTS = 'SET_PROJECTS';
